import { css } from 'styled-components';
import { IStyled } from './styled.models';

export const styled = css<IStyled>`
  ${({ styled }) => (styled ? styled : '')}
`;

